@if (pro(); as pro) {
  <a
    [routerLink]="proProfileRoute"
    class="group relative isolate block rounded-lg border border-grey-300 hover:bg-grey-50"
    (click)="navigate($event)"
    *transloco="let t"
  >
    @if (pro?.yearsAsTopPartner?.length && pro.yearsAsTopPartner; as years) {
      <bgo-top-partner-banner
        [bannerText]="t('proDirectoryCard.topPartner', {year: years | bgoMax})"
        class="absolute top-0 left-[-13.5px] z-10 scale-[115%]"
      />
    }
    <div class="flex flex-col gap-xs sm:flex-row sm:gap-md sm:pt-md">
      <div class="relative aspect-video w-full overflow-hidden sm:ml-md sm:aspect-4/3 sm:w-[240px] sm:min-w-[240px]">
        @if (gallery().length) {
          <bgo-gallery
            [galleryId]="'directory-card-' + pro.slug"
            (click)="$event.stopPropagation(); $event.preventDefault()"
            class="h-[200px] sm:h-[180px]"
            [items]="gallery()"
            loadingStrategy="lazy"
            [showThumbnails]="false"
            [flushMobileBottom]="true"
            counterPosition="bottom"
          ></bgo-gallery>
        } @else {
          <div
            class="ratio-video sm:ratio-[4/3] absolute top-0 left-0 flex h-full w-full items-center justify-center bg-president-500 text-center heading-4xl text-grey-50 sm:rounded-sm"
          >
            {{ getFirstLetter(pro.name) }}
          </div>
        }
      </div>
      <div class="min-w-0 flex-1 space-y-sm px-sm sm:mr-md sm:px-0" #informationContent>
        <div class="">
          <h3 class="text-md font-bold">{{ pro.name }}</h3>
          <p class="mb-xs text-base">{{ pro.industries.join(' • ') }}</p>
          <div class="flex gap-xs">
            @if (pro.locations | slice: 0 : 1; as defaultLocation) {
              <cft-chip colour="grey-lighter"
                ><span class="flex gap-xs text-president-800">
                  <fa-icon [icon]="locationIcon"></fa-icon>
                  {{ defaultLocation[0] | bgoFullLocation }}
                </span>
              </cft-chip>
            }
            @if (pro.locations | slice: 1; as additionalLocations) {
              @if (additionalLocations.length) {
                <span [cftDropdown]="locationsDropdown" (click)="showLocationsDropdown($event)">
                  <cft-chip colour="grey-lighter">
                    <span class="flex gap-xs text-president-800"
                      >+{{ additionalLocations.length }}
                      <fa-icon [icon]="dropdownIcon"></fa-icon>
                    </span>
                  </cft-chip>
                </span>
                <cft-dropdown #locationsDropdown="cftDropdown">
                  <ng-template cftDropdownContent>
                    <div class="divide-y focus:outline-hidden">
                      @for (additionalLocation of additionalLocations; track additionalLocation) {
                        <a class="group flex items-center px-sm py-xs text-sm">
                          {{ additionalLocation | bgoFullLocation }}
                        </a>
                      }
                    </div>
                  </ng-template>
                </cft-dropdown>
              }
            }
          </div>
        </div>
        @if (pro.locations | bgoAverageGooglePlace) {
          <div class="flex flex-wrap gap-xs border-b border-grey-300 pb-md group-hover:border-grey-400 sm:border-b-0">
            @if (pro.locations | bgoAverageGooglePlace; as googlePlace) {
              <a [routerLink]="proProfileRoute" fragment="pro-profile-locations" (click)="navigate($event)">
                <cft-google-rating
                  [rating]="googlePlace.rating"
                  [numReviews]="googlePlace.userRatingCount"
                ></cft-google-rating>
              </a>
            }
          </div>
        }
        @if (pro.description) {
          <div class="line-clamp-3 text-sm">
            {{ pro.description }}
          </div>
        }
        @if (metrics().length) {
          <bgo-pro-directory-card-metrics
            [metrics]="metrics()"
            [parentContainerWidth]="informationContent.offsetWidth"
          ></bgo-pro-directory-card-metrics>
        }
      </div>
    </div>
    <div class="flex justify-between p-sm sm:mt-md sm:border-t sm:border-grey-300 sm:group-hover:border-grey-400">
      <a [routerLink]="proProfileRoute" class="btn max-w-1/2 btn-ghost">
        <div class="inline-flex w-[1.5em] justify-center">
          <fa-icon [icon]="profileIcon"></fa-icon>
        </div>
        <span class="sm:hidden">
          {{ t('proDirectoryCard.profileButton.mobile') }}
        </span>
        <span class="hidden sm:inline">
          {{ t('proDirectoryCard.profileButton.desktop') }}
        </span>
      </a>
      <a
        [routerLink]="jobRequestRoute"
        [queryParams]="{pro: pro.slug}"
        (click)="navigate($event)"
        class="btn-left-icon mr-0 ml-auto btn flex max-w-1/2 gap-xs btn-secondary-vermilion bg-white"
      >
        <fa-icon [icon]="plusIcon"></fa-icon>
        <span class="sm:hidden">
          {{ t('proDirectoryCard.jobRequestButton.mobile') }}
        </span>
        <span class="hidden sm:inline">
          {{ t('proDirectoryCard.jobRequestButton.desktop') }}
        </span>
      </a>
    </div>
  </a>
}
